import { render, staticRenderFns } from "./NotificationView.vue?vue&type=template&id=8f30a090&scoped=true"
import script from "./NotificationView.vue?vue&type=script&lang=js"
export * from "./NotificationView.vue?vue&type=script&lang=js"
import style0 from "./NotificationView.vue?vue&type=style&index=0&id=8f30a090&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f30a090",
  null
  
)

export default component.exports